import { Component, input } from '@angular/core';
import { IonCardTitle } from '@ionic/angular/standalone';

@Component({
  selector: 'x-card-title',
  imports: [IonCardTitle],
  templateUrl: './x-card-title.component.html',
  styleUrl: './x-card-title.component.scss',
})
export class XCardTitleComponent {
  cssClass = input<string>('');
}
